const businessComperation = () =>
  import("@/views/business-comperation-module/BusinessComperation.vue");
const businessComperationDetail = () =>
  import("@/views/business-comperation-module/BusinessComperationDetail.vue");
let router = [
  {
    path: "/design/businessComperation",
    name: "businessComperation",
    component: businessComperation,
    meta: {
      title: "企业合作"
    }
  },
  {
    path: "/design/businessComperationDetail",
    name: "businessComperationDetail",
    component: businessComperationDetail,
    meta: {
      title: "企业合作详情"
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/businessComperation/index.js